export function HoneypotField({ id, inputRef }) {
  return (
    <div aria-hidden="true" className="sr-only">
      <label htmlFor={id}>Fax</label>
      <input ref={inputRef} id={id} name="fax" type="text" tabIndex={-1} autoComplete="off" />
    </div>
  );
}